import { render, staticRenderFns } from "./AssetHistoryLog.vue?vue&type=template&id=85410270"
import script from "./AssetHistoryLog.vue?vue&type=script&lang=js"
export * from "./AssetHistoryLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports